import React from 'react';
import { ContactInfo as SectionKey } from 'Consts/Questionnaire';
import TextInput from '../Fields/TextInput';
import RadioInput from '../Fields/RadioInput';
import PhoneInput from '../Fields/PhoneInput';
import USStateInput from '../Fields/USStateInput';
import Section from '../Section';
import { advisorView } from '../../../../Context/ViewContext';

const ContactInfo = () => (
  <Section
    transitionSpeed={0.25}
    height={400}
    title="Contact Information"
    sectionKey={SectionKey}
  >
    <TextInput
      placeholder="Address 1"
      name="address1"
      answerKey="clientAddress1"
      maxLength={128}
      requiredView={advisorView}
    />
    <TextInput
      placeholder="Address 2"
      name="address2"
      answerKey="clientAddress2"
      maxLength={128}
      requiredView={advisorView}
    />
    <TextInput
      placeholder="City"
      name="city"
      answerKey="clientCity"
      maxLength={32}
      requiredView={advisorView}
    />
    <USStateInput
      label="State"
      name="state"
      answerKey="clientState"
      requiredView={advisorView}
    />
    <TextInput
      placeholder="ZIP"
      name="zip"
      answerKey="clientZip"
      maxLength={10}
      requiredView={advisorView}
    />
    <PhoneInput
      placeholder="Cell phone"
      name="cellPhone"
      answerKey="clientCellPhone"
      requiredView={advisorView}
    />
    <PhoneInput
      placeholder="Home phone"
      name="homePhone"
      answerKey="clientHomePhone"
      requiredView={advisorView}
    />
    <PhoneInput
      placeholder="Other Phone"
      name="otherPhone"
      answerKey="clientOtherPhone"
      requiredView={advisorView}
    />
    <RadioInput
      label="Preferred contact method"
      name="preferredContactMethod"
      answerKey="clientPreferredContactMethod"
      options={[
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'email',
          text: 'Email',
        },
        {
          id: 'phone',
          text: 'Phone',
        },
      ]}
    />
  </Section>
);

export default ContactInfo;
